<template>
	<div class="image-picker">
		<div v-show="previewUrl">
			<img class="preview" :src="previewUrl" :style="{ 'max-width': previewW + 'px' }">
			<b-button v-if="isDeleteButtonShow" type="is-danger" class="delete-button ml-20" icon-right="delete" @click="onDeleteClick" />
		</div>
		<b-field class="file mt-15">
			<b-upload v-model="file" @input="onFileChange">
				<a class="button is-success" :class="{ 'is-loading': isLoading }">
					<span>アップロード</span>
				</a>
			</b-upload>
		</b-field>
	</div>
</template>

<script>

export default {
	name: 'ImagePicker',
	props: {
		previewUrl: {
			type: String,
			default: '',
		},
		isLoading: {
			type: Boolean,
			default: false,
		},
		previewW: {
			type: Number,
			default: 100,
		},
		isDeleteButtonShow: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			file: null,
		}
	},
	mounted() {
	},
	methods: {
		onFileChange: function() {
			if (!this.file || !this.file.type.match(/^image\/(png|jpeg)$/)) {
				alert('画像ファイルを指定してください');
				return;
			}

			let reader = new FileReader();
			reader.readAsDataURL(this.file);
			reader.onload = (e) => {
				this.$emit('file-change', e.target.result);
			};
		},
		onDeleteClick: function() {
			this.$emit('delete');
		},
	},
}
</script>

<style lang="scss">
@import "@/scss/_vars.scss";

.file,
.image-picker {
	display: inline-block;
}

.preview {
	height: auto;
	border: $commonBorder;
}

.delete-button {
	width: 30px;
}

.file {
	span {
		font-weight: $extraBold;
	}
}
</style>
